export default __webpack_public_path__ + "7a0962f4dc87b62c142e68b1939b2817.svg";